module.exports = __webpack_public_path__ + "9779d9a1/img/splash-icon.07a7c465.svg";